export const API_SERVER = process.env.REACT_APP_API_SERVER || 'http://localhost:9000';
export const ACCESS_TOKEN_KEY = process.env.ACCESS_TOKEN_KEY || 'access-token';
export const ACCESS_ADMIN_TOKEN_KEY = 'access-admin-token';
// Widget preview CDN bundle. Hardcoded (not env) so a stale REACT_APP_CDN_JS_URL
// secret cannot break preview after the client CDN hash changes.
// Update this hash when cixon-finance-client is redeployed to GitHub Pages.
export const CDN_GENERATOR_PATH =
  'https://cixon-gmbh.github.io/cixon-finance-cdn/static/js/main.c7f61d2c.js';

// Environment mode - controls Sentry integration
export const ENV_MODE = process.env.REACT_APP_MODE || 'prod';
export const IS_DEV_MODE = ENV_MODE === 'dev';

// Support tab: HubSpot ticket form (portal 6754890, EU) and the HubSpot customer portal.
// Public embed IDs, not secrets. The form must be registered for cixon.finance in HubSpot
// (Additional site domains), otherwise submissions are filtered to spam.
export const HUBSPOT_PORTAL_ID = '6754890';
export const HUBSPOT_REGION = 'eu1';
export const SUPPORT_FORM_ID = '59efcd19-5b8b-431a-b856-a07e101842ce';
export const SUPPORT_PORTAL_URL = 'https://cixon.de/helpdesk';
